import { render } from "./Saving_Account_Details.vue?vue&type=template&id=a6e1c9dc&scoped=true"
import script from "./Saving_Account_Details.vue?vue&type=script&lang=js"
export * from "./Saving_Account_Details.vue?vue&type=script&lang=js"

import "./Saving_Account_Details.vue?vue&type=style&index=0&id=a6e1c9dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e1c9dc"]])

export default __exports__